import { render, staticRenderFns } from "./editWorkType.vue?vue&type=template&id=61badf8c&scoped=true"
import script from "./editWorkType.vue?vue&type=script&lang=js"
export * from "./editWorkType.vue?vue&type=script&lang=js"
import style0 from "./editWorkType.vue?vue&type=style&index=0&id=61badf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61badf8c",
  null
  
)

export default component.exports